import { FuseClassPrefixProvider, setFuseClassPrefix } from "@tvg/fuse/class-prefix";
import React from "react";
import { FUSE_CLASS_PREFIX } from "../../shared/fuseClassPrefix";

export const withFusePrefix = (element: React.ReactElement): React.ReactElement => {
  if (typeof setFuseClassPrefix === "function") {
    setFuseClassPrefix(FUSE_CLASS_PREFIX);
  }

  return <FuseClassPrefixProvider classPrefix={FUSE_CLASS_PREFIX}>{element}</FuseClassPrefixProvider>;
};

export default withFusePrefix;
